import { Stack } from '@mui/material';

import { InformationExtractionExamplesFormField } from './Examples/FormFields';
import { InformationExtractionExtractionFieldsFormField } from './ExtractionFields/FormFields';
import { InformationExtractionModelSettingsFormField } from './ModelSettings/FormFields';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function InformationExtractionFormFields() {
  return (
    <Stack spacing={2}>
      <BlockValueTemplateField
        fieldName="config.documents"
        label="Documents"
        required
        helperText="List of documents with text field or a single document text"
        placeholder={`You can set {{previousBlock.data}} which can have an array of documents format [{
  "text": "document text",
  ... any additional metadata can be added here
}] or a single text format "document text"`}
      />

      <Stack>
        <InformationExtractionExtractionFieldsFormField />
        <InformationExtractionExamplesFormField />
        <InformationExtractionModelSettingsFormField />
      </Stack>
    </Stack>
  );
}
